<template>
    <div class="page">
        <!-- 上方提示 -->
        <MTips />
        <MQuery @search="search" @addMerchant="addMerchant" />
        <DeleteDialog :ids="ids" ref="deleteDialog" @deleteBind="deleteConfirm"/>
        <EditDialog :id="id" :bindCode="bindCode"  ref="editDialog" />
        <div class="table-box">
            <el-table v-if="bandsCon" :data="bandsCon.content" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="45"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="100"></el-table-column>
                <el-table-column prop="accountName" label="商户名称" width="120"></el-table-column>
                <el-table-column prop="accountId" label="商户号/登录号" width="150"></el-table-column>
                <el-table-column prop="accountType" label="商户账户类型" width="110">
                  <template slot-scope="scope">
                      <div>{{scope.row.accountType==='userId'?'个人':'商户'}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="channel" label="支付类型" width="80"></el-table-column>
                <el-table-column prop="merchantType" label="商户类型" width="150"></el-table-column>
                <el-table-column prop="relationType" label="关系描述" width="150"></el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <div class="btn blue" @click="editMerchant(scope.row.bindCode)">修改</div>
                        <div class="btn red" @click="deleteMerchant(scope.row.id)">删除</div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <span v-show="selectedItem.length == 0"></span>
                <span class="delete" v-show="selectedItem.length > 0" @click="deleteMerchant()">删除</span>
                <Pagination :params="params" @changeSize="changeSize" @changePage="changePage" />
            </div>
        </div>
    </div>
</template>

<script>
import MTips from '@set-up/components/m-tip.vue';
import MQuery from '@set-up/components/m-query.vue';
import DeleteDialog from '@set-up/components/delete-dialog.vue';
import EditDialog from '@set-up/components/edit-dialog.vue';
import { mapActions,mapGetters} from 'vuex';
export default {
  name: 'merchants',
  components: {
    MTips,
    MQuery,
    DeleteDialog,
    EditDialog,
  },
  computed:{
    ...mapGetters('merchants', ['searchForm','bandsCon']),
  },
  data() {
    return {
      params: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      }, //翻页
      selectedItem: [], // 选中的数量
      ids: [],
      id: '',
      bindCode:''
    };
  },
  created() {
    this.searchForm.mainMerchant=JSON.parse(localStorage.getItem('merchantInfo')).hyUid; //分账方商户号
    //获取绑定关系列表
    this.getBinds(this.searchForm).then(()=>{
      if(this.bandsCon)this.params.total=this.bandsCon.total
    });
  },
  methods: {
    ...mapActions('merchants', ['getBinds','deleteBind','getBindInfo']),
    //查询
    async search(form) {
      await this.getBinds(form);
    },
    //新增
    addMerchant() {
      this.id = '';
      this.$refs.editDialog.openDialog();
    },
    handleSelectionChange(val) {
      console.log(val);
      this.selectedItem = val;
      // this.list = val
    },
    //改变每页条数
    changeSize(val) {
      this.params.pageSize = val;
      this.searchForm.pageSize=val;
      this.getBinds(this.searchForm);
    },
    //改变页数
    changePage(val) {
      this.params.pageNum = val;
      this.searchForm.pageNum=val;
      this.getBinds(this.searchForm);
    },
    //修改
    editMerchant(bindCode) {
      this.id = bindCode;
      this.$refs.editDialog.openDialog(this.id);
    },
    /**
     * @description 删除/批量删除的方法
     * @param id {Number | String} 删除的id，如果没有此参数，则是批量删除，从selectedItem中找就行
     */
    deleteMerchant(id) {
      let ids = [];
      if (id) {
        ids = [id];
      } else {
        ids = this.selectedItem.map((v) => v.id);
      }
      this.ids = ids;
      this.$refs.deleteDialog.openDialog();
    },
    async deleteConfirm(){
      await this.deleteBind(this.ids);
      await this.getBinds(this.searchForm);
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.table-box {
  margin-top: 10px;
  background-color: #fff;
  border-radius: 5px;
  padding-bottom: 50px;
  position: relative;
}
.btn {
  cursor: pointer;
}
.blue {
  color: #4359b7;
}
.red {
  color: #ff5f5f;
}
.pagination {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  border: 1px solid #f8f8f8;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  .delete {
    color: #ff5f5f;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
